import axios from 'axios';
import { AsyncAction } from '..';
import { AssetLog } from '../../types/asset';

type State = {
    fetching: boolean;
    logs: AssetLog[];
    error?: Error;
};

type Action = { type: 'asset/logs/reset' } | { type: 'asset/logs/get'; payload?: { logs: AssetLog[] }; error?: Error };

const initialState: State = {
    fetching: false,
    logs: [],
};

export const reducer = (state = initialState, action: Action): State => {
    switch (action.type) {
        case 'asset/logs/reset': {
            return { ...initialState };
        }
        case 'asset/logs/get': {
            if (action.payload) return { ...state, fetching: false, ...action.payload };
            if (action.error) return { ...state, fetching: false, error: action.error };
            return { ...state, fetching: true };
        }
        default:
            return state;
    }
};

/**
 * Reset the reducer to the initial state.
 */
const reset = (): Action => ({ type: 'asset/logs/reset' });

/**
 * Fetch the logs of the current asset.
 *
 * @param rethrow throw the internal error
 */
const get = (rethrow = false): AsyncAction => async (dispatch, getState) => {
    const { asset } = getState();
    try {
        dispatch({ type: 'asset/logs/get' });
        if (!asset.asset) throw new Error('asset not in store');
        if (asset.asset?.code === '#') return void dispatch({ type: 'asset/logs/get', payload: { logs: [] } });
        const response = await axios.get<AssetLog[]>(`/assets/${asset.asset.code}/logs`);
        const logs = response.data.sort((a, b) => +a.date - +b.date);
        dispatch({ type: 'asset/logs/get', payload: { logs } });
    } catch (error) {
        dispatch({ type: 'asset/logs/get', error });
        if (rethrow) throw error;
    }
};

export const creators = { reset, get };
